const getters = {
    users: (state) => state.users,
    links: (state) => state.links,
    page: (state) => state.page,
    managers: (state) => state.managers,
}

export default getters